import { buildToastElement } from "lib/toast"

const displaySuccessFlash = function() {
  $(document).ajaxComplete(function(event, jqxhr, settings) {
    if (settings.method == "GET" || settings.type == "GET") { return }

    let response = jqxhr.responseJSON;
    if (!response || !response.flash) { return }

    let container = document.querySelector(".toast-container")
    if (!container) { return }

    _.map(response.flash, (message, type) => {
      container.appendChild(buildToastElement({ type, message }))
    })
  })
}

const displayErrorFlash = function() {
  $(document).ajaxError(function(event, jqxhr, settings) {
    let response = jqxhr.responseJSON;

    if (jqxhr.status == 403 && response && response.flash) {
      let container = document.querySelector(".toast-container")
      if (!container) { return }

      _.map(response.flash, (message, type) => {
        container.appendChild(buildToastElement({ type, message }))
      })
    }
  })
}

export {displaySuccessFlash, displayErrorFlash};
